import { Music } from "../Util/Music/Music"

export class LabelTypes{
  static byNotePosition:number = -1
  static byNoteIndex:number = -2
  static byNoteName:number = -3
}
export class CourseState{
    setter:Function
    openHelpers:number[]
    accidental:number
    volume:number
    constructor(setter:Function){
      this.setter = setter
      this.openHelpers = []
      this.accidental = Music.sharp
      this.volume = 0.5
    }
    setVolume = (volume:number) => {
      const volumeSetter = (state:CourseState)=>{
        return({ volume:volume })
      }
      this.setter(volumeSetter)
    }
    addOpenHelper = (helperIndex:number) => {
      const addHelper = (state:CourseState)=>{
        const freshHelpers:number[] = state.openHelpers.concat([helperIndex])
        return({ openHelpers: freshHelpers })
      }
      this.setter(addHelper)
    }
    removeOpenHelper = (helperIndex:number) => {
      const removeHelper = (state:CourseState)=>{
        const helpersClone:number[] = state.openHelpers.concat()
        const arrIndex:number = helpersClone.indexOf(helperIndex)
        if(arrIndex > -1){
          helpersClone.splice(arrIndex, 1)
        }
        return({openHelpers:helpersClone})
      }
      this.setter(removeHelper)
    }
    setOpenHelpers = (openHelpers:number[]) => {
      return(this.setState({ openHelpers: openHelpers }) ) 
    }
    setState = (obj:any) => {
      this.setter((state:CourseState) => (obj))
    }
  }